var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconAddImage = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 30,
  height: 30,
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_1245",
  "data-name": "Group 1245",
  transform: "translate(-388 -276)"
}, /*#__PURE__*/React.createElement("g", {
  id: "add_a_photo-24px",
  transform: "translate(388 276)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2552",
  "data-name": "Path 2552",
  d: "M0,0H30V30H0Z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2553",
  "data-name": "Path 2553",
  d: "M3.871,10.032a1.29,1.29,0,0,0,2.58,0V7.451h2.58a1.29,1.29,0,0,0,0-2.58H6.451V2.29a1.29,1.29,0,0,0-2.58,0v2.58H1.29a1.29,1.29,0,0,0,0,2.58h2.58Z",
  transform: "translate(0 0.29)",
  fill: "#545454"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_86",
  "data-name": "Ellipse 86",
  cx: 3.779,
  cy: 3.779,
  r: 3.779,
  transform: "translate(12.209 13.527)",
  fill: "#545454"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1244",
  "data-name": "Group 1244"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2554",
  "data-name": "Path 2554",
  d: "M25.355,6.58H21.418l-1.54-1.742A2.432,2.432,0,0,0,18.052,4H10.1a2.66,2.66,0,0,1,.348,1.29,2.541,2.541,0,0,1-2.484,2.58H6.726v1.29a2.541,2.541,0,0,1-2.484,2.58A2.418,2.418,0,0,1,3,11.38V24.644a2.541,2.541,0,0,0,2.484,2.58H25.355a2.541,2.541,0,0,0,2.484-2.58V9.161A2.541,2.541,0,0,0,25.355,6.58ZM15.42,23.354A6.336,6.336,0,0,1,9.21,16.9a6.336,6.336,0,0,1,6.21-6.451,6.336,6.336,0,0,1,6.21,6.451A6.336,6.336,0,0,1,15.42,23.354Z",
  transform: "translate(0.871 0.195)",
  fill: "#545454"
}))))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconAddImage, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_add_image.eb68e49d.svg";
export { ForwardRef as ReactComponent };